//angular imports
import { WritableSignal, signal } from "@angular/core";

//local imports
import { NodeModel } from "@shared/data/models";
import { IBreadcrumbItemModel } from "@shared/components/breadcrumb/models/breadcrumb-item.model";

export class FilterGroupModel extends NodeModel<FilterGroupModel | IBreadcrumbItemModel>
{    
    public title: WritableSignal<string>;
    
    constructor (input: { id?: string, title?: string, depth: number, children?: NodeModel<FilterGroupModel | IBreadcrumbItemModel>[] }) {
        super({ id: input.id, data: null, depth: input.depth, children: input.children });
        this.id = input.id;
        this.title = signal<string>(input.title);        
    }

        
}
